/**
 * Move and Step.
 *
 * RULE DCC-MOVE-001 - Crawlers & Customization p.16.
 * A crawler moves 20 feet with a Move Action and may Step 10 feet whenever they
 * spend an Action in combat. These values can change through Third Floor race
 * choices, items, curses or System AI fiat, none of which are implemented yet.
 */
export const BASE_MOVE_FEET = 20;
export const BASE_STEP_FEET = 10;

export interface MovementModifierSource {
  label: string;
  moveFeet?: number;
  stepFeet?: number;
}

export interface Movement {
  moveFeet: number;
  stepFeet: number;
}

export function resolveMovement(sources: readonly MovementModifierSource[] = []): Movement {
  let moveFeet = BASE_MOVE_FEET;
  let stepFeet = BASE_STEP_FEET;
  for (const source of sources) {
    moveFeet += source.moveFeet ?? 0;
    stepFeet += source.stepFeet ?? 0;
  }
  return { moveFeet, stepFeet };
}

/**
 * RULE DCC-MOVE-002 - Rules for Survival p.26.
 * In a race or chase, each racer adds their Move score divided by 10, rounded
 * down, to their movement Skill Checks.
 */
export function moveRateModifier(moveFeet: number): number {
  return Math.floor(moveFeet / 10);
}
